import * as React from 'react';
import { withRouteData } from 'react-static';

import LocationsPageComponent from '../../components/LocationsPage/LocationsPage';
import { LocationsPageLocale } from '../../components/LocationsPage/locationsPage.locale';

interface LocationsPageProps {
  locale: LocationsPageLocale;
}

const LocationsPage: React.SFC<LocationsPageProps> = ({ locale }) => (
  <LocationsPageComponent locale={locale} />
);

export default withRouteData(LocationsPage);



// WEBPACK FOOTER //
// /www/client/src/containers/LocationsPage/LocationsPage.tsx